
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amanaki-boutique-saigon/the-hotel",
      function () {
        return require("private-next-pages/amanaki-boutique-saigon/the-hotel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amanaki-boutique-saigon/the-hotel"])
      });
    }
  